import React from "react";
import { Button, Row, Col } from "react-bootstrap";
import news from "../pdf/news.pdf";
import C_notice from "../pdf/C_notice.pdf";

const Notices = () => {
  return (
    <>
      <section className="p-5 mx-md-5">
        <h1>Notices</h1>
        <Row className="mt-4">
          <Col md={3} sm={10}>
            <Button
              size="md"
              href="https://vcourts.gov.in/virtualcourt/"
              target="_blank"
              className="w-100"
            >
              {" "}
              Pay Your Traffic Challan
            </Button>
          </Col>
          <Col md={1} sm={10} className="mt-1 mt-md-0">
            <Button href={news} size="md" className="w-100" target="_blank">
              {" "}
              News{" "}
            </Button>
          </Col>

          <Col md={2} sm={10} className="mt-1 mt-md-0">
            <Button href={C_notice} size="md" className="w-100" target="_blank">
              {" "}
              Court Notice{" "}
            </Button>
          </Col>
          <Col md={2} sm={10} className="mt-1 mt-md-0">
            <Button
              size="md"
              href="https://dehradun.dcourts.gov.in/holiday-list/"
              target="_blank"
              className="w-100"
            >
              {" "}
              Holiday List{" "}
            </Button>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default Notices;
